import React, { useEffect, useState } from "react";
import styles from "./Submission.module.scss";
import IconButton from "../../../../components/ButtonIcon/ButtonIcon";
import ems_logo from "../../../../../../images/v2/ems.png";
import nuvei_logo from "../../../../../../images/v2/nuvei.png";
import nab_logo from "../../../../../../images/v2/nab.png";
import priority_logo from "../../../../../../images/v2/priority.png";
import FileIcon from "../../../../assets/svg/icons/common/file";
import kurv_logo from "../../../../../../images/v2/kurv-logo.png";
import Submit from "./SubmitModal";
import ChevronRight16 from "../../../../assets/svg/icons/common/ChevronRight16";
import EditSubmissionDataModal from "../Metadata/EditSubmissionDataModal/EditSubmissionDataModal";
import useUserStore from "../../../../stores/user";

function SubmissionItem({ processor, processorFiles, appData }) {
  const [expanded, setExpanded] = useState(false);
  const [files, setFiles] = useState([]);
  const [openSubmit, setOpenSubmit] = useState(false);

  const getLogo = (processor) => {
    if (processor == "ems") return ems_logo;
    if (processor == "ems direct") return ems_logo;
    if (processor == "nuvei") return nuvei_logo;
    if (processor == "nab") return nab_logo;
    if (processor == "priority") return priority_logo;
    if (processor == "kurv") return kurv_logo;
  };

  useEffect(() => {
    Object.entries(processorFiles).forEach(([bank, files]) => {
      if (bank.toLowerCase().includes(processor.value)) {
        setFiles(files);
      }
    });
  }, [processorFiles]);

  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  return (
    <>
      <div className={styles.submission_item}>
        <div className={styles.item_head}>
          <input type="checkbox" />
          <IconButton onClick={() => setExpanded(!expanded)}>
            <ChevronRight16 />
          </IconButton>
        </div>

        <div className={styles.body}>
          <div className={styles.processor}>
            <img src={getLogo(processor.value)} />
            <h6>{processor.value}</h6>
          </div>

          <div className={styles.action}>
            {/* <p>Sent:24/12/2019</p> */}
            <IconButton
              bgColor={"#4C70EF"}
              textColor="#FFF"
              onClick={() => {
                setOpenSubmit(true);
              }}
            >
              Submit
            </IconButton>
          </div>
        </div>
      </div>

      <div
        className={`${styles.submission_data} ${expanded ? styles.expanded : ""}`}
      >
        {expanded && (
          <div
            className={`${styles.submission_data_list} ${expanded ? styles.submitted : ""}`}
          >
            {files.map((file, index) => (
              <div key={index} className={styles.list_item}>
                <FileIcon />
                <span>{file}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <Submit
        isOpen={openSubmit}
        onClose={() => {
          setOpenSubmit(false);
        }}
        appData={appData}
        files={files}
        processor={processor}
      />
    </>
  );
}

export default SubmissionItem;
